import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const WalletConnectIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/wallet-connect.png" style={style} />
}
